const styles = {
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        width: '299px',
        height: '21px',
        marginBottom: '8px',
    },
    container: {
        display: 'flex',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '24px',
        width: '299px',
        height: '21px',
    },
    cap: {
        textTransform: 'capitalize',
    },
    profileButton: {
        background: '#178900',
        borderRadius: '16px',
        width: '184px',
        height: '48px',
        marginTop: '28px',
    },
    denyAccess: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ED0000',
        textAlign: 'center',
        textTransform: 'none',
        marginTop: '38px',
    },
};
export default styles;
